module.exports = "/assets/site/images/vitorlazas.jpg?e78ee551b0341cc23a1b94cb979125b8";